import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const ADD_DISCOUNTS = SERVER_URI + '/discounts';
const GET_DISCOUNT = SERVER_URI + '/get-discounts';
const DISCOUNT_STATUS = SERVER_URI + '/discount-status/';
const UPDATE_DISCOUNT_DATA = SERVER_URI + '/discounts/';


export default {

    addDiscounts:async function(paylaod){
      console.log("discount payload", paylaod)
      return apiPost(ADD_DISCOUNTS,paylaod)
    },
    getDiscount: async function (payload) {
        console.log('pay',payload);
        return apiPost(GET_DISCOUNT,payload);
      },
      DiscountStatus: async function (id) {
        return apiGet(DISCOUNT_STATUS + id);
      },
      updateDiscountData: async function (id,payload) {
        console.log("immd.....", id,payload)
        return apiPut(UPDATE_DISCOUNT_DATA +id,payload)
      }
}